import BaseService from "./BaseService";

export default class SituacaoAcademicaService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterSituacaoAcademica(parameters) {
    return this.ExecutaFetch("/api/SituacaoAcademica/ObterSituacaoAcademica", "POST", parameters);
  }

  CadastrarSituacaoAcademica(parameters) {
    return this.ExecutaFetch("/api/SituacaoAcademica/CadastrarSituacaoAcademica", "POST", parameters);
  }

  ExcluirSituacaoAcademica(parameters) {
    return this.ExecutaFetch("/api/SituacaoAcademica/ExcluirSituacaoAcademica", "POST", parameters);
  }
}